import APIModel from "../APIModel";

export default class Profile extends APIModel {
  constructor() {
    super("profile");
  }
}
